module.exports = __webpack_public_path__ + "assets/img/wh5_p07.5478110e.png";